/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "resources": {
            "nested": {
              "Document": {
                "fields": {
                  "type": {
                    "type": "squareup.corporate_card.resources.Document.Type",
                    "id": 1,
                    "rule": "optional"
                  },
                  "fileName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "fileContent": {
                    "type": "bytes",
                    "id": 3,
                    "rule": "optional"
                  },
                  "contentType": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Type": {
                    "values": {
                      "T_DO_NOT_USE": 0,
                      "CARD_STATEMENT": 1,
                      "PRELIMINARY_CARDHOLDER_AGREEMENT": 2,
                      "CARDHOLDER_AGREEMENT": 3,
                      "CALIFORNIA_FINANCE_DISCLOSURE": 4,
                      "NEW_YORK_FINANCE_DISCLOSURE": 5,
                      "PRELIMINARY_CALIFORNIA_FINANCE_DISCLOSURE": 6,
                      "PRELIMINARY_NEW_YORK_FINANCE_DISCLOSURE": 7,
                      "FLORIDA_FINANCE_DISCLOSURE": 8,
                      "GEORGIA_FINANCE_DISCLOSURE": 9,
                      "PRELIMINARY_FLORIDA_FINANCE_DISCLOSURE": 10,
                      "PRELIMINARY_GEORGIA_FINANCE_DISCLOSURE": 11,
                      "KANSAS_FINANCE_DISCLOSURE": 12,
                      "PRELIMINARY_KANSAS_FINANCE_DISCLOSURE": 13,
                      "UTAH_FINANCE_DISCLOSURE": 14,
                      "PRELIMINARY_UTAH_FINANCE_DISCLOSURE": 15
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.Document && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.Document?.nested?.Type) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc A document
 * --
 *
 * SOURCE Document @ squareup/corporate_card/resources/document.proto at 11:1
 */
export const Document = $root.lookupType('squareup.corporate_card.resources.Document');
fixType(Document, {
  type: {
    required: true
  },
  fileName: {
    required: true
  },
  contentType: {
    required: true
  }
});
Builder.createAndAttachToType(Document);
/**
 * SOURCE Type @ squareup/corporate_card/resources/document.proto at 12:3
 */
Document.Type = $root.lookupEnum('squareup.corporate_card.resources.Document.Type').values;